import React from 'react'
import './login.scss'
import { useAuth0 } from '@auth0/auth0-react'

export const LoginButton = () => {
    const {loginWithRedirect} = useAuth0();

    return (

            <button className="btn btnLogin" onClick={() => loginWithRedirect()}>
            <span>Login</span>
            </button>
        
    )
}